var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.color,style:({
    padding: _vm.padding === undefined ? '5px 7px' : _vm.padding,
    display: 'inline-block',
    borderRadius: '0.5rem',
    height: 'min-content',
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }